<template>

	<div>

		<button class="btn btn-sm btn-primary" @click="onNewBlock">Create block</button>

		<form @submit.prevent="onSearchBlocks">
			<input type="text" v-model="search.term">
			<button class="btn btn-primary">Search</button>
			<button class="btn " @click="result.active = false,search.term = ''">clean</button>
		</form>

		<ul class="block-categories">
			<li v-for="category in blockCategories">
				<span>{{category.id}} {{ category.name }}</span>
				<span class="btn btn-sm btn-outline-primary" @click="onEditCategory(category)" title="Edit">E</span>
				<span class="btn btn-sm btn-outline-warning" @click="promptOrderCategory(category)" title="order">O</span>
				<button class="btn btn-sm btn-danger" v-if="category.blocks.length==0" @click="deleteCategory(category)">D</button>
				<ul v-if="category.blocks" class="category-blocks">
					<li v-for="block in category.blocks" :title="block.name">
						<div class="d-flex justify-content-between align-items-center mb-1">
							<strong>{{ block.name }}</strong>
							<div>
								<span class="btn btn-sm btn-outline-warning" @click="onEdit(block)" title="Edit">E</span>
								<a target="_blank" :href="'/erp/export-block/'+block.id" class="btn btn-outline-primary btn-sm" title="export">X</a>
								<span class="btn btn-sm btn-outline-warning" @click="promptCategory(block)" title="Category">C</span>
								<span class="btn btn-sm btn-outline-warning" @click="promptOrderBlock(block)" title="order">O</span>
								<span class="btn btn-sm btn-outline-danger" @click="deleteBlock(block)" title="delete">D</span>
								<span class="btn btn-sm btn-outline-primary" @click="autoThumbnail(block)" title="generate thumb">Img</span>
							</div>
						</div>
						<img v-if="block.image" :src="block.image">
					</li>
				</ul>
			</li>
		</ul>

		<form class="m-2" v-show="formImportCategories" @submit.prevent="onSubmitCategories">
			<textarea ref="inputCategories" class="form-control"></textarea>
			<button type="submit">submit</button>
			<button class="btn btn-light" @click.prevent="formImportCategories = false">Cancel</button>
		</form>

		<form class="m-2" v-show="formImportBlocks" @submit.prevent="onSubmitBlocks">
			<textarea ref="inputBlocks" class="form-control"></textarea>
			<button type="submit">submit</button>
			<button class="btn btn-light" @click.prevent="formImportBlocks = false">Cancel</button>
		</form>

		<div class="p-3 d-flex justify-content-between align-items-center">
			<div>
				<input class="mr-1" type="text" v-model="screenshotSize">
				<label class="mr-1"><input type="checkbox" v-model="screenshotTrim"> trim</label>
			</div>

			<div>
				<button class="btn btn-success" @click="formImportCategories = true">import categories</button>
				<button class="btn btn-success" @click="formImportBlocks = true">importar blocks</button>
			</div>

			<div>
				<a href="/erp/export-categories" target="_blank" class="btn btn-primary">exportar all categories</a>
				<a href="/erp/export-blocks" target="_blank" class="btn btn-primary">exportar all blocks</a>
			</div>

			<div>
				<button class="btn btn-danger" @click="truncate">delete all</button>
			</div>


		</div>


		<div class="modal  modal-active" v-if="modalEditCategory">
			<div class="modal-dialog">
				<div class="modal-content">

					<div class="form-group">
						<label>Name</label>
						<input v-model="category.name" class="form-control" required>
					</div>

					<div class="form-group">
						<label>Icon (svg)</label>
						<textarea v-model="category.icon" class="form-control"></textarea>
						<span v-if="category.icon" v-html="category.icon" style="max-width:40px; max-height: 40px;"></span>
					</div>

					<div class="form-group">
						<label>Order</label>
						<input type="number" v-model="category.order" class="form-control" required>
					</div>

					<span class="btn btn-primary" @click="onSubmitCategory">submit</span>
					<span class="btn btn-light" @click="modalEditCategory = false;">Close</span>
				</div>
			</div>
		</div>

		<div class="modal  modal-active" v-if="modalEdit">
			<div class="modal-dialog">
				<div class="modal-content">

					<div class="form-group">
						<label>Name</label>
						<input v-model="block.name" class="form-control" required>
					</div>

					<div class="form-group">
						<label>Category</label>
						<select v-model="block.category_id" class="form-control" required>
							<option v-for="category in categories" :value="category.id">{{category.name}}</option>
						</select>
					</div>

					<div class="form-group">
						<label>Template</label>
						<textarea v-model="block.template"  class="form-control" required></textarea>
					</div>
					<div class="form-group">
						<label>Css</label>
						<textarea v-model="block.css"  class="form-control"></textarea>
					</div>
					<div class="form-group">
						<label>Js</label>
						<textarea v-model="block.js"  class="form-control"></textarea>
					</div>
					<div class="form-group">
						<label>Order</label>
						<input type="number" v-model="block.order" class="form-control" required>
					</div>
					<div class="form-group">
						<label>Uid</label>
						<input v-model="block.uid" class="form-control">
					</div>
					<div class="form-group">
						<label>Keywords</label>
						<input v-model="block.keywords" class="form-control">
					</div>
					<span class="btn btn-primary" @click="onSubmit">submit</span>
					<span class="btn btn-light" @click="modalEdit = false;">Close</span>
				</div>
			</div>
		</div>


		<div class="modal modal-center modal-active" v-if="modalCategory">
			<div class="modal-dialog">
				<div class="modal-content">
					<select v-model="category_id" class="form-control">
						<option v-for="category in categories" :value="category.id">{{category.name}}</option>
					</select>
					<span class="btn btn-primary" @click="setCategory">submit</span>
					<span class="btn btn-light" @click="modalCategory = false;">Close</span>
				</div>
			</div>
		</div>

		<div class="modal modal-center modal-active" v-if="modalOrderBlock">
			<div class="modal-dialog">
				<div class="modal-content">
					<input type="number" min="0" v-model="order" class="form-control">
					<span class="btn btn-primary" @click="setOrderBlock">submit</span>
					<span class="btn btn-light" @click="modalOrderBlock = false;">Close</span>
				</div>
			</div>
		</div>


		<div class="modal modal-center modal-active" v-if="modalOrderCategory">
			<div class="modal-dialog">
				<div class="modal-content">
					<input type="number" min="0" v-model="order" class="form-control">
					<span class="btn btn-primary" @click="setOrderCategory">submit</span>
					<span class="btn btn-light" @click="modalOrderCategory = false;">Close</span>
				</div>
			</div>
		</div>

	</div>

</template>
<style scoped>

ul { list-style:none; margin:0; padding:0; }
.block-categories { padding:20px; background:#f5f5f5; }
.block-categories > li { margin-bottom:10px; }
.block-categories > li > span { font-weight:bold;}
.block-categories > li > button { }
.block-categories ul { display:flex; flex-wrap:wrap;}
.block-categories ul li { width:300px; padding:15px; border-radius:5px; background:#fff; box-shadow:1px 1px 3px rgba(0,0,0,.2); margin:0 10px 10px; }
.block-categories ul li img { max-width:100%; height:auto; max-height:150px; display:block;}

.modal   { display:none; background:rgba(0,0,0,.5)}


.modal-active { display:block; }
.modal-active.modal-center   { display:flex; align-items:center; justify-content:center; }
.modal-dialog   {
	width:100%; width:calc(100% - 20px);
	max-width:600px;
	max-height:90vh;
	background-color:#fff; box-shadow:1px 1px 5px rgba(0,0,0,.8);
	position:relative;
}
.modal-close   { position:absolute; top:-0.5em; right:-0.5em; cursor:pointer; background:#fff; border-radius:50px; display:inline-block; width:1em; height:1em; text-align:center; font-size:20px; font-weight:bold; line-height:1; color:rgba(0,0,0,.5); }
.modal-title   { padding:20px; border-bottom:1px solid #ccc; }
.modal-content   { padding:20px;  }

</style>
<script>

	import componentFunctions from '@/mixin.components.js'
	import axios from 'axios';
	import Vue from 'vue';

	export default window.vmPage = {
		mixins:[componentFunctions],
		data() {
			return {
				screenshotSize:'1280,600',
				screenshotTrim:true,
				formImportCategories:false,
				formImportBlocks:false,
				modalCategory:false,
				modalOrderBlock:false,
				modalOrderCategory:false,
				modalEdit:false,
				modalEditCategory:false,
				block_id:null,
				category_id:null,
				order:99,
				block:{},
				category:{},
				search:{term:''},
				result:{
					active:false,
					rows:[],
				}
			}
		},
		computed:{
			categories(){
				var rows = [];
				if(this.result.active) {
					rows = this.result.rows
				} else{
					rows = this.$store.getters.allblocks;
				}


				return rows.map(category=>{
					return {id:category.id,name:category.name};
				})
			},
			blockCategories(){
				if(this.result.active) {
					return this.result.rows
				} else{
					return this.$store.getters.allblocks;
				}

			},
		},
		mounted(){
			this.getBlocks();
			console.log(this.$refs);

		},
		methods:{



			promptOrderBlock(block){
				this.block_id =block.id;
				this.order =block.order;
				this.modalOrderBlock = true;
			},
			setOrderBlock(){
				axios({
					method: 'post',
					url: '/erp/reorder-block/'+this.block_id,
					data:{ order:this.order },
				}).then(()=>{
					this.getBlocks();
					this.modalOrderBlock = false;
				});
			},

			promptOrderCategory(category){
				this.category_id =category.id;
				this.order =category.order;
				this.modalOrderCategory = true;
			},
			setOrderCategory(){
				axios({
					method: 'post',
					url: '/erp/reorder-category/'+this.category_id,
					data:{ order:this.order },
				}).then(()=>{
					this.getBlocks();
					this.modalOrderCategory = false;
				});
			},

			promptCategory(block){
				this.block_id =block.id;
				this.category_id =block.category_id;
				this.modalCategory = true;
			},
			setCategory(){
				var data = {
					category_id:this.category_id
				};
				axios({
					method: 'post',
					url: '/erp/block/'+this.block_id,
					data:data,
				}).then(()=>{
					this.getBlocks();
					toastr('ok','','lightgreen');
					this.modalCategory = false;
				}).catch(res=>{
					toastr('falha','','red');
					console.error(res);
				});

			},


			truncate(){
				if(!confirm('are you sure?')) return;

				axios({
					method: 'post',
					url: '/erp/truncate',
				}).then(()=>{
					this.getBlocks();
					toastr('ok','','lightgreen');
				}).catch(res=>{
					toastr('falha','','red');
					console.error(res);
				});


			},
			deleteBlock(block){
				if(!confirm('are you sure?')) return;
				axios({
					method: 'post',
					url: '/erp/delete-block/'+block.id,
				}).then(()=>{
					this.getBlocks();
					toastr('ok','','lightgreen');
				}).catch(res=>{
					toastr('falha','','red');
					console.error(res);
				});

			},
			deleteCategory(category){
				if(!confirm('are you sure?')) return;
				axios({
					method: 'post',
					url: '/erp/delete-category/'+category.id,
				}).then(()=>{
					this.getBlocks();
					toastr('ok','','lightgreen');
				}).catch(res=>{
					toastr('falha','','red');
					console.error(res);
				});

			},

			onSubmitCategories(){
				var data = {
					categories:this.$refs.inputCategories.value
				};
				axios({
					method: 'post',
					url: '/erp/import-categories',
					data: data
				}).then(()=>{
					this.getBlocks();
					toastr('ok','','lightgreen');
				}).catch(res=>{
					toastr('falha','','red');
					console.error(res);
				});

			},

			onEditCategory(category){
				this.category = JSON.parse(JSON.stringify(category))
				this.modalEditCategory = true;
			},

			onSubmitCategory(){
				var data = this.category;
				axios({
					method: 'post',
					url: '/erp/category'+(data.id?'/'+data.id:''),
					data: data
				}).then(()=>{
					this.getBlocks();
					toastr('ok','','lightgreen');
					this.modalEditCategory = false;
				}).catch(res=>{
					toastr('falha','','red');
					console.error(res);
				});

			},


			onEdit(block){
				this.block = JSON.parse(JSON.stringify(block))
				this.modalEdit = true;
			},

			onNewBlock(){
				this.block = {};
				this.modalEdit = true;

			},

			onSubmit(){
				var data = this.block;
				axios({
					method: 'post',
					url: '/erp/block'+(data.id?'/'+data.id:''),
					data: data
				}).then(()=>{
					this.getBlocks();
					toastr('ok','','lightgreen');
					this.modalEdit = false;
				}).catch(res=>{
					toastr('falha','','red');
					console.error(res);
				});

			},

			onSearchBlocks(){
				var data = this.search;
				axios({
					method: 'post',
					url: '/erp/searchBlocks',
					data: data
				}).then((res)=>{
					this.result.rows = res.data;
					this.result.active = true;
				}).catch(res=>{
					toastr('falha','','red');
					console.error(res);
				});


			},


			onSubmitBlocks(){
				var data = {
					blocks:this.$refs.inputBlocks.value
				};
				axios({
					method: 'post',
					url: '/erp/import-blocks',
					data: data
				}).then(()=>{
					this.getBlocks();
					toastr('ok','','lightgreen');
				}).catch(res=>{
					toastr('falha','','red');
					console.error(res);
				});

			},

			getBlocks(){
				this.$store.dispatch('getBlocks');
			},


			deleteBlock(block){
				if(!confirm('Certeza?')) return;
				axios({
					method: 'delete',
					url: '/api/block/'+block.id,
				}).then(()=>{
					toastr('ok','','lightgreen');
					this.getBlocks();
				});
			},

			autoThumbnail(block){

				var params = [];
				params.push('size='+this.screenshotSize);
				if(this.screenshotTrim) params.push('trim=1');

				var url = '/api/block-screenshot/'+block.id+'?'+params.join('&');

				axios.get(url).then((response)=> {
					this.getBlocks();
					toastr('ok','','lightgreen');

				}).catch((error) =>  {
					console.error(error);
					if(error.response) alert(error.response.data);
				})
			},

		}

	}


</script>

